import Vue from 'vue'
import App from './App.vue'
import router from './router'
import moment from "moment";
Vue.config.productionTip = false

moment.locale('de');


Vue.filter('moment', (date: moment.MomentInput) => moment(date).format('ll'));


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
